import type { NumberFieldData } from '@stratumn/studio-shared';

export const initialNumberData: NumberFieldData = {
  title: 'Default Number Field Title',
  placeholder: '',
  required: true,
  type: 'number'
};
